import { useState, useEffect } from "react";
import { INIT_ERRORS_FORM, INIT_ERROR_TEXTS_FORM, INIT_FORM } from "../constants";
import { errorFree } from "utils/validations";

const useForm = ({
    currentGroupRoomResourceForUpdate,
    resourceTypeIdToCreate,
    currentCampusFilterId
}) => {
    //#region States
    const [form, setForm] = useState({ ...INIT_FORM });
    const [errors, setErrors] = useState({ ...INIT_ERRORS_FORM });
    const [errorTexts, setErrorTexts] = useState({ ...INIT_ERROR_TEXTS_FORM });
    //#endregion
    //#region Effects
    useEffect(() => {
        if (currentGroupRoomResourceForUpdate || form.groupRoomOutOfLibrary) return;
        setForm(prev => ({
            ...prev,
            environment: "",
            address: ""
        }));
    }, [form.groupRoomOutOfLibrary]);
    useEffect(() => {
        setForm(prev => ({
            ...prev,
            resourceTypeId: resourceTypeIdToCreate.value,
            campusId: currentCampusFilterId
        }));
    }, []);
    useEffect(() => {
        if (!currentGroupRoomResourceForUpdate) return;
        setForm({ ...currentGroupRoomResourceForUpdate });
    }, [currentGroupRoomResourceForUpdate]);
    //#endregion
    //#region Functions
    const changeField = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: typeof (value) === "function" ? value(prev[field]) : value
        }));
    }
    const toggleGroupRoomOutOfLibrary = () => {
        setForm(prev => ({
            ...prev,
            groupRoomOutOfLibrary: !prev.groupRoomOutOfLibrary
        }));
    }
    const isValidCapacityNumber = (value = null) => {
        return Number(value !== null ? value : form.capacity) >= 2;
    }
    const areThereChanges = () => {
        if (!currentGroupRoomResourceForUpdate) return true;
        const {
            capacity,
            screenId,
            environment,
            address,
            details
        } = currentGroupRoomResourceForUpdate;
        return (
            form.capacity !== capacity ||
            form.details !== details || 
            form.screenId !== screenId ||
            (form.groupRoomOutOfLibrary && (
                form.environment !== environment ||
                form.address !== address
            ))
        );
    }
    const areThereErrors = () => {
        return !errorFree(errors);
    }
    const isCompletedForm = () => {
        const {
            campusId, libraryId,
            resourceTypeId, capacity,
            screenId, groupRoomOutOfLibrary, 
            environment
        } = form;
        return (
            campusId !== 0 && 
            libraryId !== 0 &&
            resourceTypeId &&
            capacity &&
            screenId !== 0 &&
            (!groupRoomOutOfLibrary || environment)
        );
    }
    const changeErrors = value => {
        setErrors(prev => ({
            ...prev,
            ...value
        }));
    };
    const changeErrorTexts = value => {
        setErrorTexts(prev => ({
            ...prev,
            ...value
        }));
    };
    //#endregion
    return {
        form: {
            value: form,
            set: setForm,
            change: changeField,
            areThereChanges,
            isCompleted: isCompletedForm,
            toggleGroupRoomOutOfLibrary,
            isValidCapacityNumber
        },
        errors: {
            value: errors,
            change: changeErrors,
            areThere: areThereErrors
        },
        errorTexts: {
            value: errorTexts,
            change: changeErrorTexts
        }
    }
}

export default useForm;